import { countryFullNameMap } from "../models/label-maps";

export const mapCountryFullName = (country: string): string => countryFullNameMap[country] ?? country;
